import React from 'react';

import { ListingPhoto } from '@ha/api/v2/types/Listing';
import { SwipeableContext } from 'ha/modules/SwipeableSlider';
import { LoadablePanoramaViewer } from 'ha/components/PanoramaViewer';

interface Props {
  images: ListingPhoto[];
}
const PanoramicPicturesContainer: React.FC<Props> = ({ images }) => (
  <SwipeableContext.Consumer>
    {context => (
      <LoadablePanoramaViewer
        currentScene={context.slideIndex}
        images={images}
      />
    )}
  </SwipeableContext.Consumer>
);

export { PanoramicPicturesContainer };
